// eslint-disable-next-line no-unused-vars
/* global REDUX_DEVTOOLS */
import { compose } from 'redux';

// Use the Redux devtools composer if the extension exists
const enhance = window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: 'builder-ui' })
  : compose;

async function getReduxConfig() {
  if (import.meta.env.REDUX_DEVTOOLS) {
    // Reactotron ships as CJS with `__esModule`, and Vite's interop can surface
    // the real export either directly on `.default` (pre-bundled) or wrapped one
    // level deeper under `module.exports.default` (served raw). Unwrap defensively
    // so this works regardless of how the dep is served.
    const reactotronModule = await import('reactotron-react-js');
    const reactotronExports = reactotronModule.default ?? reactotronModule;
    const Reactotron = reactotronExports.default ?? reactotronExports;

    const reduxModule = await import('reactotron-redux');
    const reduxExports = reduxModule.default ?? reduxModule;
    const reactotronRedux =
      reduxExports.reactotronRedux ?? reduxModule.reactotronRedux;

    const sagaModule = await import('reactotron-redux-saga');
    const sagaExports = sagaModule.default ?? sagaModule;
    const sagaPlugin = sagaExports.default ?? sagaExports;

    const reactotron = Reactotron.configure({
      name: 'builder-ui',
    })
      .use(reactotronRedux())
      .use(sagaPlugin())
      .connect();

    const sagaMonitor = reactotron.createSagaMonitor();

    return {
      composeEnhancers: enhancers =>
        enhance(enhancers, reactotron.createEnhancer()),
      sagaMonitor,
      logStateChange: (store, name) => {
        store.subscribe(() => {
          Reactotron.display({
            name: `${name} state updated`,
            value: store.getState(),
          });
        });
      },
    };
  }

  return {
    composeEnhancers: compose,
    sagaMonitor: undefined,
    logStateChange: () => {},
  };
}

export default getReduxConfig;
